import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["loading", "datatable", "table"]

  connect() {
    $(this.tableTarget).on("init.dt", this.tableInitialized.bind(this))
    this.setupDataTable()
  }

  tableInitialized() {
    $(this.loadingTarget).hide()
    $(this.datatableTarget).fadeIn()
    this.overrideModalLinkClickAction()
  }

  setupDataTable() {
    $(this.tableTarget).dataTable({
      autoWidth: false,
      destroy: true,
      processing: true,
      iDisplayLength: 25,
      lengthMenu: [10, 25, 50, 100, 200, 500],
      stateSave: true,
      stateDuration: 300,
      serverSide: true,
      order: [[0, "desc"]],
      searching: true,
      deferRender: true,
      responsive: true,
      ajax: this.element.dataset.datatablesUrl,
    })
  }

  overrideModalLinkClickAction() {
    $(document).on("click", ".modal-link", function(e) {
      e.preventDefault()
      $.ajax({
        url: $(this).attr("href"),
        dataType: "json",
        success: function(data) {
          $("#details-modal .modal-dialog").html(data.content)
          $("#details-modal").modal("show")
        },
        error: function(err) {
          console.log(err)
        }
      })
    })
  }
}
